import { createAPI } from '@common'

export default {
  // 查询文件夹信息
  getFolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0f60benjo0epn0gpmefs', 'get', config),
  // 新增文件夹
  postFolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0f60benjo0epn0gpmefst', 'post', config),
  // 获取稿源库子节点（非配置树
  getOriginFolders: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0f60gpmefst', 'get', config),
  // 删除文件夹
  deleteFolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0f60benjo0epn0gpmefst', 'delete', config),
  // 获取根节点
  getRoot: (config) => createAPI('customEncryptApiName-1/0nfejby.tztufn0gpmefs0sppu', 'get', config),
  getNewRoot: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0f60gpmefst0cz0epdMjct', 'get', config),
  // 获取子节点
  getSubs: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0f60benjo0epn0gpmefst', 'get', config),
  // 获取流程
  getE5AdminFlows: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0f60gmpxt', 'get', config),
  // 获取文件夹共享状态
  postShareInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0tibsf0jogp', 'post', config)
}
